/* eslint-disable */
/* istanbul ignore file */
import React, { type Dispatch, useCallback, useState } from 'react'
import { CircularProgress } from '@mui/material'
import LanguageStrings from '../../../i18n/locales'
import { gatewayDeleteCampaign } from '../../gateway-management/redux/actionCreators'
import { connect, type ConnectedProps, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import GenericModal from '../../../components/Modal'
import AuthError from '../../../components/ErrorComponents/AuthError'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import { type RootState } from '../../../store'
import { Tooltip } from '@mui/material'
import { MemoManagementInfoHeader } from '../../common/ManagementInfoHeader'

const GatewayInformationStrings = LanguageStrings().DeviceManagementCollectionStrings.GatewayInformationComponent
const httpStatus = APIConfiguration

const GatewayInformation = (props: PropsFromRedux & { parentSiteId: any, deviceAssetId: any, gatewayInfo: any, imageBinaryData: any }): JSX.Element => {
  const navigate = useNavigate()
  const [selectedGatewayId, setSelectedGatewayId] = useState('')
  const [confirmDeletePopup, setConfirmDeletePopup] = useState(false)
  const [showDeleteStatus, setShowDeleteStatus] = useState(false)
  const gatewayDeleteStatus = useSelector(
    (state: RootState) => state.gatewayDeleteState
  )

  /* istanbul ignore next */
  const handleEdit = useCallback(()=>{
    navigate(`/edit-gateway/${props.gatewayInfo.gatewayInfo.id}`, {
      state: {
        parentSiteId: props.parentSiteId,
        deviceAssetId: props.deviceAssetId
      }
    })
  },[props])

  /* istanbul ignore next */
  const handleDelete = useCallback(()=>{
    setSelectedGatewayId(props.gatewayInfo.gatewayInfo.id)
    setConfirmDeletePopup(true)
  },[props])

  /* istanbul ignore next */
  const handleDeleteCampaign = (): void => {
    setConfirmDeletePopup(false)
    setShowDeleteStatus(true)
    props.gatewayDeleteCampaign(selectedGatewayId)
  }

  const formatTextWithTooltip = (text: string): JSX.Element => {
    if (text?.length > 40) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 40)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : '-'}</span>
  }

  const handleDeleteCampaignWithFailure = (): JSX.Element => {
    /* istanbul ignore next */
    if (gatewayDeleteStatus.httpStatus === httpStatus.SUCCESS_HTTP_STATUS) {
      return (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={GatewayInformationStrings.successfullyDeleted}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/gateway-list/${props.deviceAssetId}`, { state: { parentSiteId: props.parentSiteId } }) // Redirect after closing the modal
          }}
          onClose={() => {
            setShowDeleteStatus(false)
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            navigate(`/gateway-list/${props.deviceAssetId}`, { state: { parentSiteId: props.parentSiteId } }) // Redirect after closing the modal
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {GatewayInformationStrings.FullMsgAssetDeletedSuccessfully}
          </p>
        </GenericModal>
      )
    } else if (gatewayDeleteStatus.isLoading) {
      return (
        <GenericModal title={'Loading...'}>
          <div className="CircularprogressAmi">
            <CircularProgress />
          </div>
        </GenericModal>
      )
    } else if (gatewayDeleteStatus.httpStatus === httpStatus.BAD_REQUEST) {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {gatewayDeleteStatus.error} </p>
        </GenericModal>
      )
    } else if (gatewayDeleteStatus.httpStatus === httpStatus.UNAUTHORIZED_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="Unauthorized" />
        </div>
      )
    } else if (gatewayDeleteStatus.httpStatus === httpStatus.ACCESS_FORBIDDEN_HTTP_STATUS) {
      return (
        <div className="authError">
          <AuthError errorMessage="accessForbidden" />
        </div>
      )
    } else {
      return (
        <GenericModal
          buttonTypeNegative="hollow"
          title={'Failed'}
          LabelPositive="Okay"
          onClickPositive={() => {
            setShowDeleteStatus(false)
          }}
          onClose={() => {
            setShowDeleteStatus(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}> {gatewayDeleteStatus.error} </p>
        </GenericModal>
      )
    }
  }

  return (
    <>
       <MemoManagementInfoHeader 
          title={GatewayInformationStrings.GatewayInformation}
          binaryData={props.imageBinaryData?.binaryData} 
          name={props?.gatewayInfo?.gatewayInfo?.name} 
          description={props?.gatewayInfo?.gatewayInfo?.description} 
          createdOn={props?.gatewayInfo?.gatewayInfo?.install_date}
          handleEdit={handleEdit}
          handleDelete={handleDelete} />

      {confirmDeletePopup && (
        <GenericModal
          width="600px"
          height="260px"
          buttonTypeNegative="hollow"
          title={'Delete Gateway'}
          LabelPositive="Confirm"
          LabelNegative="Cancel"
          onClickPositive={handleDeleteCampaign}
          onClose={() => { setConfirmDeletePopup(false) }}
          onClickNegative={() => { setConfirmDeletePopup(false) }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {GatewayInformationStrings.DeleteConfirmation}<br/><br/>
            {GatewayInformationStrings.DeleteConfirmationWarning}
          </p>
        </GenericModal>
      )}
      {
        /* istanbul ignore next */
        showDeleteStatus && handleDeleteCampaignWithFailure()
      }
    </>
  )
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  gatewayDeleteCampaign: (selectedGatewayId: string) => { dispatch(gatewayDeleteCampaign(selectedGatewayId)) }
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(GatewayInformation)
